import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { MapTypeAppState, ShowTimeLineState } from "../../appState";
import { LinkIconConfig, RouterConfig } from "../../config";
import { MapTypeEnum } from "../../enum";
import { Resource } from "../../resource";
import RangeInput from "../rangeInput/rangeInput";
import TooltipV2 from "../tooltipV2/tooltipV2";
import "./timeLine.scss";
import { AppData } from "../../data";

const TimeLine = () => {
    const mapType = useRecoilValue(MapTypeAppState)
    const showTimeLine = useRecoilValue(ShowTimeLineState)
    const location = useLocation()

    const [showTime3d, setShowTime3d] = useState(false)
    const [openTimeLine, setOpenTimeLine] = useState(false)
    const [yearState, setYearState] = useState(new Date()?.getFullYear())

    useEffect(() => {
        let checkShow = mapType == MapTypeEnum.map3d && (location?.pathname == RouterConfig.home || showTimeLine)
        if (!checkShow) {
            setOpenTimeLine(false)
        }
        setShowTime3d(checkShow)
    }, [mapType, location, showTimeLine])
    const handleOpenTimeLine = () => {
        setOpenTimeLine(prev => !prev)
    }

    const handleCloseTimeLine = () => {
        setOpenTimeLine(false)
    }

    const handleChangeYear = (value) => {
        let date = new Date(value, 1, 1, 0, 0, 0);
        AppData.map.setDate(date)
        setYearState(value)
    }

    let min = new Date()?.getFullYear() - 10
    let max = new Date()?.getFullYear() + 10
    return (
        showTime3d && <>
            <TooltipV2 description={Resource.timeLine.status} anchor={"left"}>
                <div className="timeLineButton" onClick={handleOpenTimeLine} style={{ backgroundColor: `${openTimeLine ? '#1C75BC' : '#ffffff'}` }}>
                    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
                        <defs>
                            <clipPath id="clip-path">
                                <rect id="Rectangle_30107" data-name="Rectangle 30107" width="24" height="24" transform="translate(-19369 -7950)" fill={`${openTimeLine ? '#ffffff' : '#1C75BC'}`} stroke="#707070" strokeWidth="1" />
                            </clipPath>
                        </defs>
                        <g id="Mask_Group_81004" data-name="Mask Group 81004" transform="translate(19369 7950)" clipPath="url(#clip-path)">
                            <g id="time-watch-svgrepo-com" transform="translate(-19367 -7948)">
                                <g id="Group_81916" data-name="Group 81916">
                                    <g id="Group_81915" data-name="Group 81915">
                                        <path id="Path_14824" data-name="Path 14824" d="M19.546,8.237,17.9,7.711A8.162,8.162,0,0,0,17.2,6.035L18,4.5a.652.652,0,0,0-.119-.76L16.263,2.122A.652.652,0,0,0,15.5,2L13.966,2.8A8.162,8.162,0,0,0,12.29,2.1L11.764.455A.652.652,0,0,0,11.143,0H8.857a.652.652,0,0,0-.621.454L7.71,2.1A8.163,8.163,0,0,0,6.034,2.8L4.5,2a.652.652,0,0,0-.76.119L2.121,3.738A.652.652,0,0,0,2,4.5l.792,1.537A8.161,8.161,0,0,0,2.1,7.711L.454,8.237A.652.652,0,0,0,0,8.858v2.285a.652.652,0,0,0,.454.621l1.647.526A8.162,8.162,0,0,0,2.8,13.967L2,15.5a.652.652,0,0,0,.119.76L3.737,17.88A.652.652,0,0,0,4.5,18l1.537-.792A8.162,8.162,0,0,0,7.71,17.9l.526,1.647A.652.652,0,0,0,8.857,20h2.285a.652.652,0,0,0,.621-.454L12.29,17.9a8.163,8.163,0,0,0,1.676-.695L15.5,18a.652.652,0,0,0,.76-.119l1.616-1.616A.652.652,0,0,0,18,15.5l-.792-1.537a8.161,8.161,0,0,0,.695-1.676l1.647-.526A.652.652,0,0,0,20,11.144V8.858A.652.652,0,0,0,19.546,8.237ZM10,15.7A5.7,5.7,0,1,1,15.7,10,5.706,5.706,0,0,1,10,15.7Z" transform="translate(0 -0.001)" fill={`${openTimeLine ? '#ffffff' : '#1C75BC'}`} />
                                    </g>
                                </g>
                                <g id="Group_81918" data-name="Group 81918" transform="translate(9.286 6.602)">
                                    <g id="Group_81917" data-name="Group 81917">
                                        <path id="Path_14825" data-name="Path 14825" d="M241.593,175.934l-.921-.921v-2.481a.684.684,0,1,0-1.369,0V175.3a.684.684,0,0,0,.2.484l1.121,1.121a.684.684,0,0,0,.968-.968Z" transform="translate(-239.304 -171.848)" fill={`${openTimeLine ? '#ffffff' : '#1C75BC'}`} />
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>
                </div>
            </TooltipV2>
            {
                <div
                    className={`timeLineContainer ${!openTimeLine ? 'animationHidden' : ''}`}
                >
                    <div className="boxInfo">
                        <div className="boxTitle">
                            <div>{Resource.timeLine.status}</div>
                            <TooltipV2 description={Resource.common.close} anchor='top'>
                                <div className="boxIcon" onClick={handleCloseTimeLine}>
                                    <img src={LinkIconConfig.common.closeBlack} width={16} height={16} />
                                </div>
                            </TooltipV2>
                        </div>
                        <div className="boxCaption">{Resource.timeLine.caption}</div>
                        <div className="boxRange">
                            <RangeInput
                                value={yearState}
                                step={1}
                                min={min}
                                max={max}
                                onChange={handleChangeYear}
                            />

                            <div className="boxTimeNumber">
                                <div>{min}</div>
                                <div>{Resource.common.current}</div>
                                <div>{max}</div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default TimeLine